import { render, staticRenderFns } from "./TabShow.vue?vue&type=template&id=bb04bdc6&scoped=true&"
import script from "./TabShow.vue?vue&type=script&lang=coffee&"
export * from "./TabShow.vue?vue&type=script&lang=coffee&"
import style0 from "./TabShow.vue?vue&type=style&index=0&id=bb04bdc6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb04bdc6",
  null
  
)

export default component.exports